document.addEventListener('DOMContentLoaded', function() {
  // Set initial active_index class on gallery for all product items
  document.querySelectorAll('.product-item').forEach(item => {
    const gallery = item.querySelector('.product-item__gallery');
    if (gallery) {
      gallery.classList.add('active_index');
    }
    
    // Make sure the main image doesn't have the active_index class
    const mainImage = item.querySelector('.product-item__bg');
    if (mainImage) {
      mainImage.classList.remove('active_index');
    }
  });
  
  // Initialize image sliders
  initProductImageSliders();
  
  // Initialize color swatches
  initColorSwatches();
});

function initProductImageSliders() {
  // Find all product gallery navigation elements
  const galleryNavs = document.querySelectorAll('[data-gallery-prev], [data-gallery-next]');
  
  // Add click handlers to gallery navigation
  galleryNavs.forEach(nav => {
    nav.addEventListener('click', function(e) {
      e.preventDefault();
      
      const productItem = this.closest('.product-item');
      const gallery = productItem.querySelector('.product-item__gallery');
      const mainProductImage = productItem.querySelector('.product-item__bg');
      
      // Toggle the active_index class from main image to gallery
      if (mainProductImage.classList.contains('active_index')) {
        mainProductImage.classList.remove('active_index');
        gallery.classList.add('active_index');
      }
      
      const images = gallery.querySelectorAll('.product-item__gallery-image');
      const currentActive = gallery.querySelector('.active');
      let currentIndex = Array.from(images).indexOf(currentActive);
      let newIndex;
      
      // Determine direction
      if (this.hasAttribute('data-gallery-prev')) {
        newIndex = (currentIndex - 1 + images.length) % images.length;
      } else {
        newIndex = (currentIndex + 1) % images.length;
      }
      
      // Update active state
      currentActive.classList.remove('active');
      images[newIndex].classList.add('active');
    });
  });
}

function initColorSwatches() {
  // Handle collection page color swatches
  const colorSwatches = document.querySelectorAll('.product__colors-swatch');
  
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Get the product container
      const productGridItem = this.closest('[data-product-grid-item]');
      if (!productGridItem) return;
      
      // Update active swatch
      const allSwatches = this.closest('.product__colors').querySelectorAll('.product__colors-swatch-link');
      allSwatches.forEach(s => s.classList.remove('active-swatch'));
      this.querySelector('.product__colors-swatch-link').classList.add('active-swatch');
      
      // Get variant data
      const productUrl = this.getAttribute('data-product-url');
      const productImage = this.getAttribute('data-product-image');
      const lifestyleImage = this.getAttribute('data-lifestyle-image');
      const price = this.getAttribute('data-variant-price');
      const available = this.getAttribute('data-variant-available') === 'true';
      const variantName = this.getAttribute('data-variant-name');
      
      // Get variant images array
      const variantImages = this.getAttribute('data-variant-images')?.split(',').filter(url => url.trim() !== '') || [productImage];
      
      // Update product URL
      const productLinks = productGridItem.querySelectorAll('[data-product-link]');
      productLinks.forEach(link => {
        link.setAttribute('href', productUrl);
      });
      
      // Update price
      const priceElement = productGridItem.querySelector('[data-product-price] .price');
      if (priceElement) {
        if (available) {
          priceElement.innerHTML = `<span class="new-price">${price}</span>`;
        } else {
          priceElement.innerHTML = `<span class="sold-out">${this.getAttribute('data-sold-out-content')}</span>`;
        }
      }
      
      // Update main image and toggle active_index class
      const mainImageContainer = productGridItem.querySelector('[data-product-image-default]');
      const galleryContainer = productGridItem.querySelector('.product-item__gallery');
      
      if (mainImageContainer) {
        // Add active_index class to main image and remove from gallery
        mainImageContainer.classList.add('active_index');
        if (galleryContainer) {
          galleryContainer.classList.remove('active_index');
        }
        
        mainImageContainer.setAttribute('data-product-image', productImage);
        mainImageContainer.setAttribute('data-lifestyle-image', lifestyleImage || '');
        
        // Ensure the background image style is set (for hover effects)
        if (productImage) {
          mainImageContainer.style.backgroundImage = `url(${productImage})`;
        }
        
        // Update the image source
        const imageElement = mainImageContainer.querySelector('img');
        if (imageElement) {
          imageElement.setAttribute('src', productImage);
          imageElement.setAttribute('srcset', ''); // Clear srcset to ensure our src is used
        }
      }
      
      // Update gallery images
      const gallery = productGridItem.querySelector('.product-item__gallery');
      if (gallery && variantImages.length > 0) {
        // Instead of clearing the gallery, we'll update existing images or add new ones as needed
        const currentImages = gallery.querySelectorAll('.product-item__gallery-image');
        
        // First set all existing images to inactive
        currentImages.forEach(img => img.classList.remove('active'));
        
        // Then update or add images as needed
        variantImages.forEach((imageSrc, index) => {
          // Check if we already have an image at this index
          let galleryImage = gallery.querySelector(`[data-product-gallery-image="${index}"]`);
          
          if (galleryImage) {
            // Update existing image
            const img = galleryImage.querySelector('img');
            if (img) {
              img.src = imageSrc;
              img.alt = variantName || '';
            }
          } else {
            // Create new image element if needed
            galleryImage = document.createElement('div');
            galleryImage.className = 'product-item__gallery-image';
            galleryImage.setAttribute('data-product-gallery-image', index);
            
            const img = document.createElement('img');
            img.src = imageSrc;
            img.alt = variantName || '';
            img.className = 'image__img';
            
            galleryImage.appendChild(img);
            gallery.appendChild(galleryImage);
          }
          
          // Set first image as active
          if (index === 0) {
            galleryImage.classList.add('active');
          }
        });
        
        // If we have more existing images than new variant images, hide the extras
        // instead of removing them
        if (currentImages.length > variantImages.length) {
          for (let i = variantImages.length; i < currentImages.length; i++) {
            const extraImage = gallery.querySelector(`[data-product-gallery-image="${i}"]`);
            if (extraImage) {
              extraImage.style.display = 'none';
            }
          }
        }
        
        // Make sure we show all images that should be visible
        for (let i = 0; i < variantImages.length; i++) {
          const imageToShow = gallery.querySelector(`[data-product-gallery-image="${i}"]`);
          if (imageToShow) {
            imageToShow.style.display = '';
          }
        }
      }
      
      // Update lifestyle image if available
      if (lifestyleImage) {
        const lifestyleContainer = productGridItem.querySelector('.product-lifestyle-image, .product-item__bg__under');
        if (lifestyleContainer) {
          lifestyleContainer.setAttribute('data-lifestyle-src', lifestyleImage);
          // Set the background image style - this is important for the hover effect
          lifestyleContainer.style.backgroundImage = `url(${lifestyleImage})`;
          
          const lifestyleImg = lifestyleContainer.querySelector('img');
          if (lifestyleImg) {
            lifestyleImg.setAttribute('src', lifestyleImage);
            lifestyleImg.setAttribute('srcset', '');
          }
        }
      }
      
      // Update badges
      updateBadges(this, productGridItem);
    });
  });
  
  // Handle sibling swatches
  const siblingSwatches = document.querySelectorAll('[data-sibling-link]');
  siblingSwatches.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const productGridItem = this.closest('[data-product-grid-item]');
      if (!productGridItem) return;
      
      // Update active state
      const allSiblingSwatches = productGridItem.querySelectorAll('.siblings__link');
      allSiblingSwatches.forEach(s => s.classList.remove('siblings__link--current'));
      this.closest('.siblings__link').classList.add('siblings__link--current');
      
      // Get data
      const siblingUrl = this.getAttribute('data-sibling-link');
      const siblingPrice = this.getAttribute('data-sibling-price');
      const siblingCutline = this.getAttribute('data-sibling-cutline');
      const siblingImage = this.getAttribute('data-sibling-image');
      
      // Toggle active_index class
      const mainImageContainer = productGridItem.querySelector('[data-product-image-default]');
      const galleryContainer = productGridItem.querySelector('.product-item__gallery');
      
      if (mainImageContainer) {
        // Add active_index class to main image and remove from gallery
        mainImageContainer.classList.add('active_index');
        if (galleryContainer) {
          galleryContainer.classList.remove('active_index');
        }
      }
      
      // Update product link
      const productLinks = productGridItem.querySelectorAll('[data-product-link]');
      productLinks.forEach(link => {
        link.setAttribute('href', siblingUrl);
      });
      
      // Update price
      const priceElement = productGridItem.querySelector('[data-product-price] .price');
      if (priceElement && siblingPrice) {
        priceElement.innerHTML = `<span class="new-price">${siblingPrice}</span>`;
      }
      
      // Update cutline
      const cutlineElement = productGridItem.querySelector('[data-product-cutline]');
      if (cutlineElement && siblingCutline) {
        cutlineElement.textContent = siblingCutline;
      }
      
      // Update sibling image (this is usually just the thumbnail in the swatches UI)
      const siblingImageElement = productGridItem.querySelector('[data-product-image-sibling]');
      if (siblingImageElement && siblingImage) {
        siblingImageElement.style.backgroundImage = `url(${siblingImage})`;
        siblingImageElement.style.display = 'block';
      }
      
      // Also update lifestyle image if applicable
      const lifestyleContainer = productGridItem.querySelector('.product-lifestyle-image, .product-item__bg__under');
      const lifestyleImage = this.getAttribute('data-sibling-image');
      if (lifestyleContainer && lifestyleImage) {
        lifestyleContainer.style.backgroundImage = `url(${lifestyleImage})`;
        
        const lifestyleImg = lifestyleContainer.querySelector('img');
        if (lifestyleImg) {
          lifestyleImg.setAttribute('src', lifestyleImage);
          lifestyleImg.setAttribute('srcset', '');
        }
      }
    });
  });
}

function updateBadges(swatch, productGridItem) {
  // Clear existing badges
  const badgeBox = productGridItem.querySelector('.badge-boxes');
  if (badgeBox) {
    badgeBox.innerHTML = '';
    
    // Add sale badge if applicable
    if (swatch.hasAttribute('data-on-sale-content')) {
      const saleBox = document.createElement('div');
      saleBox.className = 'sale-box-wrapper';
      saleBox.innerHTML = `<div class="sale-box badge">${swatch.getAttribute('data-on-sale-content')}</div>`;
      badgeBox.appendChild(saleBox);
    }
    
    // Add preorder badge if applicable
    if (swatch.hasAttribute('data-preorder-content')) {
      const preorderBox = document.createElement('div');
      preorderBox.className = 'preorder-box badge';
      preorderBox.innerHTML = swatch.getAttribute('data-preorder-content');
      badgeBox.appendChild(preorderBox);
    }
    
    // Add custom badges
    const customBadges = swatch.getAttribute('data-custom-badges')?.trim();
    if (customBadges && customBadges !== '') {
      customBadges.split(',').forEach(badge => {
        if (badge.trim() !== '') {
          const badgeElement = document.createElement('div');
          badgeElement.className = 'badge-box badge';
          badgeElement.innerHTML = badge.trim();
          badgeBox.appendChild(badgeElement);
        }
      });
    }
  }
}

// Note: CSS styles for the gallery should be included in your theme's CSS files
// rather than being added via JavaScript